import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sas_token";
const ORG_KEY = "sas_org_id";
export const IMPERSONATION_KEY = "sas_impersonation";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const orgStore = {
  get: () => localStorage.getItem(ORG_KEY),
  set: (id) => localStorage.setItem(ORG_KEY, id),
  clear: () => localStorage.removeItem(ORG_KEY),
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  const orgId = orgStore.get();
  if (orgId) config.headers["X-Org-Id"] = orgId;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 403 && err?.response?.data?.detail === "Account suspended") {
      tokenStore.clear();
      orgStore.clear();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/suspended")) {
        window.location.href = "/suspended";
      }
    }
    if (err?.response?.status === 401) {
      tokenStore.clear();
      orgStore.clear();
    }
    return Promise.reject(err);
  }
);

export function errorMessage(err) {
  if (!err) return "Something went wrong";
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    if (typeof first === "string") return first;
    if (first?.msg) return first.msg;
  }
  if (err?.message) return err.message;
  return "Something went wrong";
}
